YP.ScanListManager = function() {
    var mainContainer      = $('.js-scan-list-form');
    var scanListTable      = $('#scan_list_table');
    var scanListList       = $('.js-orga-event_scanlist');
    var participantCounter = $('.js-participant-nb');
    var btnOpenFilter      = $('.js-btn-open-filter');
    var filterScanList     = $('.js-filter-scanlist');

    return {
        init: function(){
            if(mainContainer.length > 0) {
                this.initScanListForm();
            }
            if(scanListTable.length > 0) {
                $('.showsearch_scanlist').live('click', this.displayFilter);
            }
            if(scanListList.length > 0) {

                var order   = "";
                var by      = "";
                var sortUrl = scanListList.data('sort');


            }
            if(filterScanList.length > 0) {
                btnOpenFilter.live('click', this.openFilterScanList);
                filterScanList.hide();
            }
        },
        initScanListForm: function() {
            klass = this;
            $(".js-scan-list-add-event").on('click', function(e){
                $(this).parent().remove();
                $('.c-grid').show();
            });

            $(".js-choose-selector .js-form__input").change(function(e) {

                val = $(this).val();
                if (val == 2) {
                    $(this).closest(".js-block-event").find('.js-choose-ticket').show();
                } else {
                    $(this).closest(".js-block-event").find('.js-choose-ticket').hide();
                }
                klass.countParticipant();
            });

            $(".js-check-ticket").change(function(e) {
                klass.countParticipant();
            });
        },
        displayFilter: function() {
            $('.js-search_ticket_scan_list').toggle();
        },
        countParticipant: function() {
            klass = this;
            $.ajax({
                type: 'POST',
                url: mainContainer.data('count-url'),
                data: mainContainer.serialize(),
                dataType: "json",
                success: function(data) {
                    participantCounter.html(data.count);
                }
            });
        },
        getAllFilters: function(){
            var _filters    = {
                "order"     : order,
                "by"        : by
            };

            return _filters;
        },
        openFilterScanList: function(){
            if(filterScanList.hasClass('js-is-open')){
               filterScanList.hide();
               filterScanList.removeClass('js-is-open');
            }
            else{
                filterScanList.show();
                filterScanList.addClass('js-is-open');
            }

        },
    };
};

window.addEventListener("load", function(){
    YP.ScanListManager().init();
});
